function getDateString(dateParam, withSlashes) {
  let date
  if (!dateParam) {
    date = new Date()
  } else {
    date = new Date(dateParam)
  }
  const dd = date.getDate()
  const mm = date.getMonth() + 1
  const yyyy = date.getFullYear()
  return withSlashes ? `${dd}/${mm}/${yyyy}` : `${dd}${mm}${yyyy}`
}

export function getDaysAgo(dateString) {
  const inputDate = new Date(dateString)
  const now = new Date()

  const diffInMs = now - inputDate

  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))

  return diffInDays > 1 ? `${diffInDays}d` : `just now`
}
export default getDateString
